var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as Long from "long";
import { selectBalancingResource } from "../balancingSelectors/selectBalancingResources";
import { selectUiDefinition } from "../balancingSelectors/selectBalancingUiDefinitions";
import { IdMenuBalancing } from "../constants/IdMenuBalancing";
import { IdModal } from "../features/modals/IdModal";
import { selectInventoryResourceInfo } from "./selectInventoryInfo";
import { selectModalTabId } from "./selectModalTabId";
export var selectFarmManagementProducts = function (state) {
    var uiDefinitions = selectUiDefinition(IdMenuBalancing.FarmManagement);
    var type = selectModalTabId(state, IdModal.FarmManagement);
    var productCategory = uiDefinitions.category.find(function (category) { return category.id === type; });
    if (productCategory == undefined) {
        return [];
    }
    return productCategory.resourceItem.map(function (resource) {
        var resourceId = resource.resourceId, otherProps = __rest(resource, ["resourceId"]);
        var resourceProto = selectInventoryResourceInfo(state, resourceId);
        var resourceBalancing = selectBalancingResource(resourceId);
        return __assign({}, resourceProto, resourceBalancing, { amount: resourceProto.amount || Long.ZERO }, otherProps);
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectFarmManagementProducts.ts
// module id = 2654
// module chunks = 3